import React, { useState, useEffect } from 'react';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import UserManagement from './components/UserManagement';
import NotificationManagement from './components/NotificationManagement';
import UserNotificationSettings from './components/UserNotificationSettings';
import NotificationTemplateManagement from './components/NotificationTemplateManagement';
import Login from './components/Login';
import { authService } from './services/auth';

interface User {
  id: string;
  nickname?: string;
  email?: string;
  role?: string;
}

function App() {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 페이지 로드 시 인증 상태 확인
    const checkAuth = () => {
      if (authService.isAuthenticated()) {
        setIsAuthenticated(true);
        // 토큰에서 사용자 정보 추출 (간단한 방법)
        const token = authService.getToken();
        if (token) {
          try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            setUser({ id: payload.userId });
          } catch (error) {
            console.error('토큰 파싱 오류:', error);
            authService.logout();
          }
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const handleLoginSuccess = (userData: User) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    authService.logout();
    setUser(null);
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">로딩 중...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <Dashboard />;
      case 'users':
        return <UserManagement />;
      case 'notifications':
        return <NotificationManagement />;
      case 'user-notification-settings':
        return <UserNotificationSettings />;
      case 'notification-templates':
        return <NotificationTemplateManagement />;
      case 'settings':
        return (
          <div className="p-6">
            <h1 className="text-3xl font-bold text-gray-900">설정</h1>
            <p className="mt-2 text-gray-600">시스템 설정을 관리하세요</p>
            <div className="mt-6 bg-white rounded-lg shadow p-6">
              <p className="text-gray-500">설정 기능은 추후 구현 예정입니다.</p>
            </div>
          </div>
        );
      default:
        return <Dashboard />;
    }
  };

  return (
    <Layout currentPage={currentPage} onPageChange={setCurrentPage} user={user} onLogout={handleLogout}>
      {renderPage()}
    </Layout>
  );
}

export default App;
